export function isNullData(data) {
  if (data === undefined) {
    return true;
  }
  if (data === null) {
    return true;
  }
  if (String(data).trim().length === 0) {
    return true;
  }
  return false;
}

export function getDBFormattedDate(date) {
  return `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
    .getDate()
    .toString()
    .padStart(2, "0")}/${date.getFullYear().toString()}`;
}

export function getViewFormattedDate(date) {
  return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getFullYear().toString()}`;
}

function reverse(text) {
  let reverse_text = text.split("");
  reverse_text = reverse_text.reverse();
  return reverse_text.join("");
}

export function formatSeparator(text, gap, separator) {
  let f_text = reverse(text.toString());
  let result = [],
    i,
    len;
  for (i = 0, len = f_text.length; i < len; i += gap) {
    result.push(f_text.substr(i, gap));
  }
  return reverse(result.join(separator));
}

export function formatHandphone(value) {
  let tag_a = value.substring(0, 1),
    tag_b = value.substring(0, 2);
  if (tag_a === "0") {
    return "(+62) " + formatSeparator(value.slice(1), 4, " ");
  } else if (tag_a === "8") {
    return "(+62) " + formatSeparator(value, 4, " ");
  } else if (tag_b === "62") {
    return "(+62) " + formatSeparator(value.slice(2), 4, " ");
  } else {
    return formatSeparator(value, 4, " ");
  }
}

export function dataURIToBlob(dataURI) {
  const splitDataURI = dataURI.split(",");
  const byteString =
    splitDataURI[0].indexOf("base64") >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
}

export function isNumeric(str) {
  if (typeof str != "string") return false; // we only process strings!
  return !isNaN(str) && !isNaN(parseFloat(str));
}

export function formatHargaFloat(angka) {
  console.log({angka})
  return angka
    .toFixed(2)
    .replace('.', ',') // ganti titik desimal jadi koma
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // tambahkan titik sebagai pemisah ribuan
}

export const data_product = [
  {
    product_id: 7470,
    product_name: {
      en_US: "ABC SAMBAL ASLI SACHET 20gr",
    },
    internal_reference: "FM-ABC001",
    company_id: 1,
    total_quantity: 15580.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7471,
    product_name: {
      en_US: "ABC SAMBAL EXTRA PEDAS 20gr",
    },
    internal_reference: "FM-ABC009",
    company_id: 1,
    total_quantity: 2130.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7473,
    product_name: {
      en_US: "ABC SAMBAL TERASI",
    },
    internal_reference: "FM-ABC005",
    company_id: 1,
    total_quantity: 760.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7475,
    product_name: {
      en_US: "ABC SARDEN CABAI 155gr",
    },
    internal_reference: "FM-ABC006",
    company_id: 1,
    total_quantity: 2340.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7476,
    product_name: {
      en_US: "ABC SARDEN CABAI 425gr",
    },
    internal_reference: "FM-ABC007",
    company_id: 1,
    total_quantity: 2256.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7478,
    product_name: {
      en_US: "ABC TERASI UDANG 3.8gr",
    },
    internal_reference: "FM-ABC002",
    company_id: 1,
    total_quantity: 6480.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7479,
    product_name: {
      en_US: "ADEM SARI CHING KU 320ml",
    },
    internal_reference: "FM-ADE001",
    company_id: 1,
    total_quantity: 16368.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7482,
    product_name: {
      en_US: "BANGO KECAP MANIS 20ml",
    },
    internal_reference: "FM-BAN001",
    company_id: 1,
    total_quantity: 8748.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7483,
    product_name: {
      en_US: "BANGO KECAP MANIS 60ml",
    },
    internal_reference: "FM-BAN002",
    company_id: 1,
    total_quantity: 19632.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7484,
    product_name: {
      en_US: "BEARBRAND 189ML",
    },
    internal_reference: "FM-BEA001",
    company_id: 1,
    total_quantity: 39150.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7485,
    product_name: {
      en_US: "BEBELAC 3 MADU 1800gr",
    },
    internal_reference: "MB-BEB009",
    company_id: 1,
    total_quantity: 12.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7487,
    product_name: {
      en_US: "BEBELAC 3 MADU 800gr",
    },
    internal_reference: "MB-BEB005",
    company_id: 1,
    total_quantity: 108.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7488,
    product_name: {
      en_US: "BEBELAC 3 VANILLA 1800gr",
    },
    internal_reference: "MB-BEB010",
    company_id: 1,
    total_quantity: 60.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7492,
    product_name: {
      en_US: "BEBELAC 4 MADU 3kg",
    },
    internal_reference: "MB-BEB015",
    company_id: 1,
    total_quantity: 112.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
  {
    product_id: 7493,
    product_name: {
      en_US: "BEBELAC 4 MADU 800gr",
    },
    internal_reference: "MB-BEB007",
    company_id: 1,
    total_quantity: 264.0,
    branch_id: 2,
    branch_name: "Legok",
    price: 10000.0
  },
];
